var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.15c-5.106 0-9.25 4.145-9.25 9.25 0 5.106 4.144 9.25 9.25 9.25s9.25-4.144 9.25-9.25c0-5.105-4.144-9.25-9.25-9.25ZM1.25 12.4C1.25 6.466 6.066 1.65 12 1.65S22.75 6.466 22.75 12.4c0 5.935-4.816 10.75-10.75 10.75S1.25 18.335 1.25 12.4Z",
    fill: "#123862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.63 7.16a.75.75 0 0 1 .75.75v4.1c0 .154.06.376.19.605.13.229.292.392.423.47l.002.001 3.1 1.85a.75.75 0 1 1-.768 1.288l-3.098-1.849h-.002c-.408-.242-.736-.623-.96-1.017-.225-.394-.386-.871-.386-1.348v-4.1a.75.75 0 0 1 .75-.75Z",
    fill: "#123862"
  })));
};
export default SvgClock;